/*compare*/
var compareKey = collections.page.compare_localstorage_key;
function GetCompareDatas(){  
  var datas = localStorage.getItem(compareKey);
  if(datas == null || datas.length == 0 ) return  [];
  try{    
    datas = JSON.parse(datas);   
    return datas;
  }catch{
    console.log('errr');
    return null;
  }
}
function AddCompareData(id){
  var data =  collections.filter(c=>c.id== id)[0];
  var datas = GetCompareDatas();  
  if(datas!=null  && typeof datas == "object" && datas.length>0){
    if(datas.some(d=>d.id!=null && d.id==id)) return;
  }
  if(data!=null) {     
    if(datas == null || typeof datas != "object") datas=[];
    datas.push(data);
    localStorage.setItem(compareKey,JSON.stringify(datas));
  }
}
function RemoveCompareDataById(id){
  var datas = GetCompareDatas();
  if(datas==null || datas.length==0) return;

  var tempData=[];

  for(var i=0;i< datas.length;i++){
     if(datas[i].id == id){
          delete datas[i];   
     }else{
      tempData.push(datas[i]);
     }
  } 
  
  if(tempData.length==0)
    localStorage.setItem(compareKey, null);
  else
    localStorage.setItem(compareKey, JSON.stringify(tempData));
}
function changecompareicon(obj,id){  

  if(obj.classList.contains('checked')){
      obj.setAttribute('src',collections.page.compare_checkbox_default_image_src);
      obj.classList.remove('checked');
      RemoveCompareDataById(id);
  }else{
        obj.setAttribute('src',collections.page.compare_checkbox_checked_image_src);      
        obj.classList.add('checked');
        AddCompareData(id);      
  } 
  ChnageCollectionsCompareBanner();
}

function change_compareicon_checkbox(obj,id){     
  if($(obj).is(':checked')){       
     AddCompareData(id);
  }else{    
     RemoveCompareDataById(id);   
  } 
  ChnageCollectionsCompareBanner();
}
function ChangeCompareButton(obj) {
  obj.querySelector('#Compare_Button').setAttribute('src', collections.page.compare_button_write_image_src);

}
function ChangeBackCompareButton(obj) {
    obj.querySelector('#Compare_Button').setAttribute('src', collections.page.compare_button_orange_image_src);   
}
function removeCompareicon(id){
  if(document.getElementById(`chk_compare_${id}`) && document.getElementById(`chk_compare_${id}`).checked){       
    document.getElementById(`chk_compare_${id}`).checked = false;    
  }
  RemoveCompareDataById(id);       
  ChnageCollectionsCompareBanner();
  
};
function ChnageCollectionsCompareBanner(){
    var datas = GetCompareDatas();
    var compareObj = document.querySelector('#dv_collections_compare_footer');
    
    if(datas==null || datas.length == 0 || typeof(datas)!="object"){
      compareObj.style.display='none';
      return;
    } 

    var _content = collections.page.comparetemplate;
    var _item = collections.page.compareitemtemplate;
   
    var parse = new DOMParser();
    _content = parse.parseFromString(_content,'text/html');
      
   var beginIndex = 0;
   if(datas.length>6) beginIndex=datas.length -6;       
    for(var i=beginIndex;i< datas.length;i++){
      var _newItem =   parse.parseFromString(_item,'text/html');

      var _imageSrc ='';
      if(datas[i].image!=null && datas[i].image.src!=null){
        _imageSrc = datas[i].image.src;
      }      
      _newItem.querySelector(".item-image").innerHTML=`<img src="${_imageSrc}" style="max-width:25px;" />`;
      _newItem.querySelector(".item-remove").setAttribute('onclick',`removeCompareicon(${datas[i].id});return false;`);
    
      _content.querySelector('#MiniDoors').appendChild(_newItem.querySelector('.col-xs-1'));       
    }

   

    compareObj.querySelector('#CompareContact').innerHTML='';
    compareObj.querySelector('#CompareContact').appendChild(_content.querySelector('.compare-down'));  
    compareObj.style.display='block';
}
function setCompareCheckedStyle(){
  var datas = GetCompareDatas();
  if(datas!=null  && typeof datas == "object" && datas.length>0){
    for(var i=0;i<datas.length;i++){
       if(document.querySelector('#compare_'+datas[i].id)){
           document.querySelector('#compare_'+datas[i].id).classList.add('checked');
           document.querySelector('#compare_'+datas[i].id).setAttribute('src',collections.page.compare_checkbox_checked_image_src);
       }
       if(document.querySelector('#chk_compare_'+datas[i].id)){
            document.querySelector('#chk_compare_'+datas[i].id).checked=true;       
       }
    }
  }
}
